/**
 * Restituisce un path interno sicuro su cui reindirizzare, o null.
 * Previene open-redirect: accetta solo path assoluti interni in whitelist
 * (la home o l'area utente /my/...). Scarta URL assoluti e protocol-relative.
 */
export function sanitizeRedirect(raw: string | null): string | null {
  if (!raw) return null;
  if (!raw.startsWith('/') || raw.startsWith('//')) return null;
  if (raw === '/' || raw.startsWith('/my/')) return raw;
  return null;
}
